<template>
 <oops v-if="showOops" :row-type="rowType"/>
  <item-page v-else
    :show-progress="showProgress"
    :item-reason="itemReason"
    :row-type="rowType"
    :item="item"
    :content-heading="contentHeading"
    :item-obj="itemReason"
    :item-name="itemName"
    :row-types="rowTypes"
    :all-prizes="AllPrizes"
    :auth="auth"
    story-header="Award Prizes"
  />
</template>
<script>
import Itempage from '@/components/Itempage'
import oops from '@/components/Oops'
import { AwardPage, Controls, AllPrizes } from '@/gql'
import { mergeControls } from '@/js/apollo'
import { SearchUtils } from '@/js'
export default {
  components: {
    'item-page': Itempage,
    oops
  },
  props: {
    auth: Object
  },
  watch: {
    Controls(val) {
      if (val.refresh) {
        this.$apollo.queries.AwardPage.refetch()
        mergeControls ({
          refresh: false
        })
      }
    }
  },
  data: () => ({
    rowTypes: ['film', 'person']
  }),
  computed: {
    showOops() {
      return !this.itemMake && !this.$apollo.loading;
    },
    contentHeading () {
      return 'Award details'
    },
    itemName () {
      return 'Award'
    },
    rowType () {
      return 'award'
    },
    award () {
      return this.itemReason
    },
    passedItem () {
      return this.params.item
    },
    showProgress () {
      return this.itemMake && !this.itemMake.big
    },
    item () {
      return this.itemMake && this.itemMake.item
    },
    itemMake () {
      // make the award query look like a reason from the summary page
      // but if we are coming from a awardpage, we'll already have some of what we need
      // so use that to start building thepage while the query is still in progress
      let item = SearchUtils.makeSearcherFromAward(this.AwardPage)
      if (item) {
        return {
          item,
          big: true
        }
      }

      // if we havent yet retrieved a award, then we'll make do with the item reason that's been inherited, if there is one
      if (!this.passedItem) {
        return null
      }

      // we got one, so make it look like it was the resubilt of a search
      item = this.passedItem
      if (this.rowType !== item.itemType) {
        console.log(`expected ${this.rowType} but got item ${item.itemType}`)
      }
      return {
        item,
        big: false
      }
    },
    params () {
      return this.$route.params
    },
    id () {
      return this.params.id
    },
    itemReason () {
      return this.item && this.item.itemReason
    }
  },
  apollo: {
    Controls: {
      query: Controls
    },
    AllPrizes: {
      query: AllPrizes
    },
    AwardPage: {
      query: AwardPage,
      variables () {
        return {
          id: this.id
        }
      }
    }
  }
}
</script>
